import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, type CommonCursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { PaginatedRailsDataObjects } from 'models/service';
import type { OrganizationScope } from '../models';

type PublicOrganizationParams = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  community_id?: string;
  group_id?: string;
  scope?: OrganizationScope;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
} & CommonCursorPaginationRailsParams;

export const getPublicOrganizations = async (params: PublicOrganizationParams) =>
  apiClient.get<
    PaginatedRailsDataObjects<components['schemas']['OrganizationBase']>,
    ApiClientResponse<PaginatedRailsDataObjects<components['schemas']['OrganizationBase']>>
  >(routes.organizations.public.find, {
    params,
  });
